import clsx from 'clsx'
import { Link } from 'react-router-dom'

import ToolLogo from './ToolLogo'
import { toolHoverHandlers } from '../../lib/prefetch'

const pricingClasses = {
  free: 'bg-accent-soft text-accent-ink',
  freemium: 'bg-bg-sunk text-ink-2',
  paid: 'bg-bg-sunk text-ink-2',
}

function slugify(value = '') {
  return value
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
}

// A real <a href>: it used to be a clickable <div>, which could not be opened
// in a new tab, was invisible to keyboard users and gave crawlers no link to
// follow. Paid placements carry a visible "Sponsored" label, as the pricing
// page promises every paid unit does.
function DenseToolCard({ tool = {} }) {
  const name = tool.name || 'Unknown Tool'
  const tagline = tool.tagline || tool.shortDescription || tool.description || ''
  const pricing = (tool.pricing || 'free').toLowerCase()
  const slug = tool.slug || slugify(name)

  return (
    <Link
      to={`/tools/${slug}`}
      {...toolHoverHandlers(slug)}
      className="group flex w-full items-center gap-3 rounded-xl border border-line bg-bg-elev p-3.5 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-accent"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden" aria-hidden="true">
        <ToolLogo tool={tool} size={36} />
      </div>

      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-semibold text-ink">{name}</h3>
        <p className="truncate text-xs text-muted">{tagline}</p>
      </div>

      <div className="flex shrink-0 flex-col items-end gap-1">
        {tool.sponsored && (
          <span
            className="rounded-full border border-line-strong bg-bg-sunk px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-ink-2"
            title="Paid placement. The maker pays for this position; it does not affect ratings or reviews."
          >
            Sponsored
          </span>
        )}
        {tool.pricing && (
          <span
            className={clsx(
              'rounded-full px-2 py-0.5 text-xs font-semibold uppercase tracking-wide',
              pricingClasses[pricing] || pricingClasses.free,
            )}
          >
            {tool.pricing}
          </span>
        )}
      </div>
    </Link>
  )
}

export default DenseToolCard
